import { slideInOutAnimation } from '@toro/common/shared/animations/slide-in-out.animation';
import { Component, OnInit } from '@angular/core';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';

@Component({
    selector: 'drafterror',
    templateUrl: './drafterror.component.html',
    animations: [slideInOutAnimation],
    host: { '[@slideInOutAnimation]': '' }
})
export class DraftErrorComponent implements OnInit {

    public logoPath = `/assets/images/${environment.isNewBrand ? 'santander': 'toro'}-red-black-small.svg`;

    constructor() { }

    ngOnInit() {
    }

}
